import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

const emissionUnits = [
  { value: "kgch4/hr", label: "kg CH₄ / h" },
  { value: "tch4/hr", label: "tons CH₄ / h" }
];

const detectionUnits = [
  { value: "kgch4/hr", label: "kg CH₄/hr" },
  { value: "tch4/hr", label: "tons CH₄/hr" }
];

const reconciliationStatuses = [
  { value: "PENDING", label: "PENDING" },
  { value: "READY", label: "READY" }
];

const SiteLevelMeasurements = ({ siteData, setSiteData, siteOptions, sources, setSources }) => {
  const handleChange = (field, value) => {
    setSiteData({ ...siteData, [field]: value });
    if (field === "emissionsUnit") {
      const updatedSources = sources.map((source) => ({
        ...source,
        emissionsUnit: value
      }));
      setSources(updatedSources);
    }
  };

  return (
    <div className="site-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Site Level Measurements
      </h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Form.Label>Site Name</Form.Label>
            </div>
            <Select
              options={siteOptions}
              value={siteOptions?.find((option) => option.value === siteData.siteName)}
              onChange={(selected) => handleChange("siteId", selected.value)}
              placeholder="Select Site"
              isSearchable
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Measurement Date & Time</Form.Label>
            <DatePicker
              selected={siteData.measurementDateTime}
              onChange={(date) => handleChange("measurementDateTime", date)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="MMMM d, yyyy h:mm aa"
              className="form-control"
              placeholderText="Select date and time"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Start Time</Form.Label>
            <DatePicker
              selected={siteData.startTime}
              onChange={(time) => handleChange("startTime", time)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              className="form-control"
              placeholderText="Select start time"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>End Time</Form.Label>
            <DatePicker
              selected={siteData.endTime}
              onChange={(time) => handleChange("endTime", time)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              className="form-control"
              placeholderText="Select end time"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Emissions</Form.Label>
            <Form.Control
              type="number"
              step="0.001"
              placeholder="Enter emissions value"
              value={siteData.emissions}
              onChange={(e) => handleChange("emissions", e.target.value)}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Emissions Unit</Form.Label>
            <Select
              options={emissionUnits}
              value={emissionUnits.find((option) => option.value === siteData.emissionsUnit)}
              onChange={(selected) => handleChange("emissionsUnit", selected.value)}
              placeholder="Select unit"
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Site Level Uncertainty</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              max="1"
              placeholder="Enter site level uncertainty"
              value={siteData.siteLevelUncertainty}
              onChange={(e) => handleChange("siteLevelUncertainty", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Source Level Uncertainty</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              max="1"
              placeholder="Enter source level uncertainty"
              value={siteData.sourceLevelUncertainty}
              onChange={(e) => handleChange("sourceLevelUncertainty", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Minimum Detection Limit</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              placeholder="Enter minimum detection limit"
              value={siteData.minimumDetectionLimit}
              onChange={(e) => handleChange("minimumDetectionLimit", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Minimum Detection Unit</Form.Label>
            <Select
              options={detectionUnits}
              value={detectionUnits.find((option) => option.value === siteData.minimumDetectionUnit)}
              onChange={(selected) => handleChange("minimumDetectionUnit", selected.value)}
              placeholder="Select unit"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-4">
            <Form.Label>Site Summary</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter summary"
              value={siteData.summary}
              onChange={(e) => handleChange("summary", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Reconciliation Ready Status</Form.Label>
            <Select
              options={reconciliationStatuses}
              value={reconciliationStatuses.find((option) => option.value === siteData.reconciliationStatus)}
              onChange={(selected) => handleChange("reconciliationStatus", selected.value)}
              placeholder="Select status"
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export { SiteLevelMeasurements };
